<template>
  <div class="viq-report-panel">
    <ViqReportTypeSelector v-if="reportStep === 0" />
    <template v-else>
      <ViqBoardReport v-if="reportType === 'board'" />
      <ViqTimeline v-else-if="reportType === 'timeline'" />
      <ViqGapAnalysis v-else-if="reportType === 'gap-analysis'" />
      <ViqMarketEntry v-else-if="reportType === 'market-entry'" />
      <ViqCompareMarkets v-else-if="reportType === 'compare-markets'" />
      <ViqExpansionOpportunity v-else-if="reportType === 'expansion'" />
      <ViqReportTypeSelector v-else />
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ViqReportPanel",
  components: {
    ViqReportTypeSelector: () => import("./ViqReportTypeSelector"),
    ViqBoardReport: () => import("./ViqBoardReport"),
    ViqTimeline: () => import("./ViqTimeline"),
    ViqGapAnalysis: () => import("./ViqGapAnalysis"),
    ViqMarketEntry: () => import("./ViqMarketEntry"),
    ViqCompareMarkets: () => import("./ViqCompareMarkets"),
    ViqExpansionOpportunity: () => import("./ViqExpansionOpportunity"),
  },
  computed: {
    ...mapState("Viq", ["reportType", "reportStep"]),
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/viq.scss";

.viq-report-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>
